// extracted by mini-css-extract-plugin
module.exports = {"link":"Link-module__link___uBGlJ"};